var a = /* @__PURE__ */ ((s) => (s.squared = "squared", s.rounded = "rounded", s))(a || {}), t = /* @__PURE__ */ ((s) => (s.default = "default", s.small = "small", s.large = "large", s))(t || {}), r = /* @__PURE__ */ ((s) => (s.default = "default", s.subtle = "subtle", s.strong = "strong", s))(r || {}), u = /* @__PURE__ */ ((s) => (s.alert = "alert", s.info = "info", s.success = "success", s.warning = "warning", s.none = "none", s))(u || {});
function n(s) {
  const e = ["status-tag"];
  switch (s.variant === "rounded" && e.push("status-tag-rounded"), s.size) {
    case "small":
      e.push("status-tag-small");
      break;
    case "large":
      e.push("status-tag-large");
      break;
  }
  switch (s.emphasis) {
    case "subtle":
      e.push("status-tag-subtle");
      break;
    case "strong":
      e.push("status-tag-strong");
      break;
  }
  switch (s.state) {
    case "alert":
      e.push("status-tag-alert");
      break;
    case "info":
      e.push("status-tag-info");
      break;
    case "success":
    default:
      e.push("status-tag-success");
      break;
    case "warning":
      e.push("status-tag-warning");
      break;
    case "none":
      e.push("status-tag-none");
      break;
  }
  return e.join(" ");
}
function l(s) {
  switch (s) {
    case "default":
      return 12;
    case "small":
      return 10;
    case "large":
      return 16;
    default:
      return 12;
  }
}
export {
  r as NovoStatusTagEmphasis,
  t as NovoStatusTagSize,
  u as NovoStatusTagState,
  a as NovoStatusTagVariant,
  l as getStatusTagIconSize,
  n as getStatusTagStyleClasses
};
